import Grid from "@mui/material/Grid";
import {Item} from "../CharStyled";
import {s_char_mv} from "../../_signals/s_char_defence";
import React from "react";
import {useSignals} from "@preact/signals-react/runtime";

export default function CharMV() {
    useSignals()
    return <Grid item sm={2} xs={4}>
        <Item>
            <div>Magische Vert:</div>
            {s_char_mv.value ?? '??'}
        </Item>
    </Grid>
}